import { useFormContext, useWatch } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { IFormValues, InsertBookingStep } from "../../../types";
import { ReactQueryKey } from "../../../../../types";
import { FormAutocomplete } from "../../../../../components/fields";
import { useRecoilValue } from "recoil";
import { stepState } from "../../../recoil";
import { IGetCompanyReturn } from "../../../../../api/services";

const FormCig = () => {

    const { t } = useTranslation('booking');

    const formContext = useFormContext<IFormValues>();  

    const step = useRecoilValue(stepState);

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const tenant = useWatch({ control: formContext.control, name: "basicDetails.tenants" });
    const dealer = useWatch({ control: formContext.control, name: "basicDetails.dealers" });

    const companyQuery = useQuery<IGetCompanyReturn | null>({
        queryKey: [ReactQueryKey.Product, {
            segment: rentalType,
            tenant: tenant as string,
            dealer: dealer as string}],
        enabled: false,
    });

    // Use Effect
    /* useEffect(() => {
        const rates = values.basicDetails.customer?.rates;
        const pa = values.basicDetails.customer.pa;
        if (rates && pa && (rates.length === 1 || values.basicDetails.product.valid)) {
            setFieldValue('basicDetails.cig', {
                code: values.basicDetails.product.valid ? rates.find(r => r.code == values.basicDetails.product.code)?.code : rates[0].code,
                label: values.basicDetails.product.valid ? rates.find(r => r.code == values.basicDetails.product.code)?.cig : rates[0].cig,
            });
        }
    }, [values.basicDetails.customer?.rates]); */

     return (
         <FormAutocomplete<IFormValues>
             name="basicDetails.cig"
             label={t('label.cig')}
             options={companyQuery?.data?.cig ?? []}
             loading={companyQuery.isLoading}
             isOptionEqualToValue={(option, value) => option === value}
             disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
         />
    )
};

export default FormCig;
